/**
 * Generic product-option and variant resolution for the build configurator.
 */
(function(global) {
  'use strict';

  function normalized(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeDefinitions(definitions) {
    return (definitions || [])
      .map(function(option) {
        return {
          name: String(option && option.name || '').trim(),
          position: parseInt(option && option.position, 10),
          values: (option && option.values || []).map(function(value) {
            return String(value);
          })
        };
      })
      .filter(function(option) {
        return option.name && option.position > 0;
      })
      .sort(function(a, b) {
        return a.position - b.position;
      });
  }

  function isColorOption(name) {
    var value = normalized(name);
    return value === 'color' || value === 'colour';
  }

  function buildOptions(definitions) {
    return normalizeDefinitions(definitions).filter(function(option) {
      return !isColorOption(option.name);
    });
  }

  function findVariantById(variants, variantId) {
    var target = String(variantId == null ? '' : variantId).trim();
    if (!/^\d+$/.test(target)) return null;
    return (variants || []).find(function(variant) {
      return String(variant && variant.id) === target;
    }) || null;
  }

  function selectionsFromVariant(definitions, variant) {
    var selections = {};
    if (!variant) return selections;

    normalizeDefinitions(definitions).forEach(function(option) {
      var value = variant['option' + option.position];
      var canonical = option.values.find(function(candidate) {
        return normalized(candidate) === normalized(value);
      });
      if (canonical != null) selections[option.position] = canonical;
    });

    return selections;
  }

  function hasSelection(selections, position) {
    return normalized(selections && selections[position]) !== '';
  }

  function isComplete(definitions, selections) {
    var options = normalizeDefinitions(definitions);
    return options.length > 0 && options.every(function(option) {
      return hasSelection(selections, option.position);
    });
  }

  function matchingVariants(variants, selections) {
    var selectedPositions = Object.keys(selections || {}).filter(function(position) {
      return hasSelection(selections, position);
    });

    return (variants || []).filter(function(variant) {
      return selectedPositions.every(function(position) {
        return normalized(variant && variant['option' + position]) === normalized(selections[position]);
      });
    });
  }

  function findExactVariant(variants, definitions, selections) {
    if (!isComplete(definitions, selections)) return null;
    var matches = matchingVariants(variants, selections);
    return matches.length === 1 ? matches[0] : null;
  }

  function isValueAvailable(variants, selections, position, value) {
    var candidate = Object.assign({}, selections || {});
    candidate[position] = value;
    return matchingVariants(variants, candidate).some(function(variant) {
      return Boolean(variant && variant.available && Number(variant.price) !== 0);
    });
  }

  function selectionSummary(options, selections) {
    var definitions = normalizeDefinitions(options);
    if (definitions.length === 0) return '';
    var selectedValues = definitions.map(function(option) {
      return String(selections && selections[option.position] || '').trim();
    });
    if (selectedValues.some(function(value) { return value === ''; })) return 'Select options';
    if (definitions.length === 1) return selectedValues[0];
    return definitions.length + ' options selected';
  }

  global.AttakyBuildOptions = {
    isColorOption: isColorOption,
    buildOptions: buildOptions,
    findVariantById: findVariantById,
    selectionsFromVariant: selectionsFromVariant,
    isComplete: isComplete,
    matchingVariants: matchingVariants,
    findExactVariant: findExactVariant,
    isValueAvailable: isValueAvailable,
    selectionSummary: selectionSummary
  };
})(window);
